module.exports = __webpack_public_path__ + "img/9791186256398.6896c39e.jpg";